var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 20,
    viewBox: "0 0 46 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0781 2.0132L23.2633 12.857L18.4782 0H14.4586L9.67353 12.857L5.15366 0H0.393555L7.42712 20H11.8159L16.4679 7.45038L21.1219 20H25.5108L30.3064 6.31204L27.0781 2.0132Z",
    fill: "#503EB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5365 3.00254C43.4704 3.93384 44.1797 5.00356 44.6643 6.20967C45.1511 7.41577 45.3923 8.70229 45.3934 10.0641C45.3934 11.427 45.1365 12.7135 44.6269 13.9196C44.1152 15.1257 43.3831 16.1954 42.4325 17.1267C41.4622 18.06 40.339 18.7715 39.0608 19.2621C37.7826 19.7547 36.4202 19.999 34.9767 19.999H27.3628V19.542L31.8577 6.71043V15.603H34.9777C35.8399 15.603 36.6344 15.4636 37.3573 15.1878C38.0801 14.912 38.7041 14.5282 39.2334 14.0356C39.7628 13.545 40.1715 12.9578 40.4638 12.2758C40.7539 11.5959 40.8985 10.857 40.8985 10.0651C40.8985 9.23766 40.7539 8.47328 40.4638 7.77404C40.1715 7.07684 39.7669 6.47633 39.2459 5.97557C38.7269 5.47684 38.1009 5.08702 37.3697 4.81323C36.6376 4.53537 35.8399 4.39796 34.9767 4.39796H30.9768L27.7861 0H34.9767C36.4566 0 37.8658 0.266666 39.2064 0.802035C39.8408 1.06158 40.4388 1.37303 41.0046 1.73537C41.5682 2.09669 42.0778 2.51807 42.5365 3.00254Z",
    fill: "#EA4160"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmall);
export default __webpack_public_path__ + "static/media/small.427464bb14c168cbac1822d65d003abb.svg";
export { ForwardRef as ReactComponent };